import React from "react";
import { Typography } from "@mui/material";
import { PageContainer, SectionHeader } from "../Layout/Common";

// Company-wide settings (Menu → Settings). Each card is a section in sections(); add new global cards there.
// Mail delivery (Resend key + From address) is not a setting any more — it lives in the backend code
// (Credentials.ResendApiKey / MailFrom); recipients are chosen per user on Admins → Set Notifications.
export default class GlobalSettingsPage extends React.Component {
    sections = () => [];

    render() {
        const sections = this.sections();
        return (
            <PageContainer maxWidth={1000}>
                <SectionHeader title="Settings" />
                {sections.length === 0
                    ? <Typography variant="body2" sx={{ color: "text.secondary" }}>No global settings yet.</Typography>
                    : sections.map(s => <React.Fragment key={s.key}>{s.render()}</React.Fragment>)}
            </PageContainer>
        );
    }
}
